import {
	CLEAR_EVENTS_COMPLETE,
	GET_COMPLETE_UPCOMING_EVENTS,
	GET_COMPLETE_UPCOMING_EVENTS_COMPLETE,
	GET_COMPLETED_EVENTS,
	GET_COMPLETED_EVENTS_COMPLETE,
	UPDATE_CURRENT_EVENT_COMPLETE,
	GET_EVENTS,
	GET_EVENTS_COMPLETE,
	GET_EVENTS_SUMMARY,
	GET_EVENTS_SUMMARY_COMPLETE,
	GET_IN_PROGRESS_EVENTS,
	GET_IN_PROGRESS_EVENTS_COMPLETE,
	GET_UPCOMING_EVENTS,
	GET_UPCOMING_EVENTS_COMPLETE,
	INIT_EVENT_DATA,
	INIT_EVENT_DATA_COMPLETE,
	OVER_WRITE_EVENT_DATA,
	OVER_WRITE_EVENT_DATA_COMPLETE,
	RESET_CURRENT_EVENT,
	RESET_EVENT_DATA,
	RESET_EVENT_DATA_COMPLETE,
	RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION,
	RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SAVE_EVENT,
	SAVE_EVENT_COMPLETE,
	SAVE_EVENT_DEFAULT_GAME_CONFIGURATION,
	SAVE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SET_REMOTE_EVENT_CHANGED,
	SET_SELECTED_EVENT_COMPLETE,
	VALIDATION_ERROR,
	SET_RULE_SET_ID_COMPLETE,
	SELECT_EVENT_STREAM_COMPLETE
} from "./constants";
import AppConfig from "../../config/app-config";
import { stateSyncEventMatch } from "../../store/middlewares/state-sync-middleware";

export const emptyPage = {
	data: [],
	pageNumber: 0,
	pageSize: AppConfig.EVENTS.PAGINATION.PAGE_SIZE,
	totalElements: 0,
	totalPages: 0
};

const initialState = {
	events: emptyPage,
	upcomingEvents: emptyPage,
	completedEvents: emptyPage,
	inProgressEvents: emptyPage,
	currentEvent: null,
	isLoading: false,
	eventsSummary: null,
	currentEventSettings: {
		gameConfiguration: null,
		customFormData: null
	},
	validationErrors: [],
	remoteEventChanged: false
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_EVENTS:
		case GET_COMPLETE_UPCOMING_EVENTS:
		case GET_EVENTS_SUMMARY:
		case INIT_EVENT_DATA:
		case SAVE_EVENT_DEFAULT_GAME_CONFIGURATION:
		case RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION:
		case SAVE_EVENT:
		case OVER_WRITE_EVENT_DATA:
		case GET_UPCOMING_EVENTS:
		case GET_COMPLETED_EVENTS:
		case GET_IN_PROGRESS_EVENTS:
		case RESET_EVENT_DATA:
			return { ...state, isLoading: true, validationErrors: [], ...payload };
		case GET_EVENTS_COMPLETE:
		case GET_COMPLETE_UPCOMING_EVENTS_COMPLETE:
		case GET_UPCOMING_EVENTS_COMPLETE:
		case GET_IN_PROGRESS_EVENTS_COMPLETE:
		case GET_COMPLETED_EVENTS_COMPLETE:
		case CLEAR_EVENTS_COMPLETE:
		case GET_EVENTS_SUMMARY_COMPLETE:
		case SET_SELECTED_EVENT_COMPLETE:
		case INIT_EVENT_DATA_COMPLETE:
		case SAVE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE:
		case RESTORE_EVENT_DEFAULT_GAME_CONFIGURATION_COMPLETE:
		case SAVE_EVENT_COMPLETE:
		case VALIDATION_ERROR:
		case SET_REMOTE_EVENT_CHANGED:
		case OVER_WRITE_EVENT_DATA_COMPLETE:
		case RESET_EVENT_DATA_COMPLETE:
		case RESET_CURRENT_EVENT:
		case UPDATE_CURRENT_EVENT_COMPLETE:
		case SET_RULE_SET_ID_COMPLETE:
			return { ...state, isLoading: false, ...payload };
		case SELECT_EVENT_STREAM_COMPLETE:
			return stateSyncEventMatch(
				state.currentEvent.id,
				payload.currentEvent.id,
				{ ...state },
				{ ...state, isLoading: false, ...payload }
			);
		default:
			return state;
	}
};

export default reducer;
